const geographicNameType = [
  'Estado',
  // 'Comunidad autónoma',
  // 'Ciudad con estatuto de autonomía',
  // 'Provincia',
  // 'Municipio',
  // 'EATIM',
  'Isla administrativa',
  'Comarca administrativa',
  'Jurisdicción',
  // 'Capital de Estado',
  // 'Capital de comunidad autónoma y ciudad con estatuto de autonomía',
  // 'Capital de provincia',
  // 'Capital de municipio',
  // 'Capital de EATIM',
  // 'Entidad colectiva',
  // 'Entidad menor de población',
  'Distrito municipal',
  // 'Barrio',
  // 'Entidad singular',
  'Construcción/instalación abierta',
  'Edificación',
  'Vértice Geodésico',
  // 'Hitos de demarcación territorial',
  // 'Hitos en vías de comunicación',
  'Alineación montañosa',
  'Montaña',
  'Paso de montaña',
  'Llanura',
  'Depresión',
  'Vertientes',
  'Comarca geográfica',
  'Paraje',
  'Elemento puntual del paisaje',
  'Saliente costero',
  'Playa',
  'Isla',
  'Otro relieve costero',
  // 'Parque Nacional y Natural',
  'Espacio protegido restante',
  // 'Aeropuerto',
  // 'Aeródromo',
  // 'Pista de aviación y helipuerto',
  // 'Puerto de Estado',
  'Instalación portuaria',
  // 'Carretera',
  'Camino y vía pecuaria',
  // 'Vía urbana',
  // 'Ferrocarril',
  'Curso natural de agua',
  'Masa de agua',
  'Curso artificial de agua',
  'Embalse',
  'Hidrónimo puntual',
  'Glaciares',
  'Mar',
  'Entrante costero y estrecho marítimo',
  'Relieve submarino',
];
export default geographicNameType;
